import React, { useState } from "react";
import InitialPage from "../components/InitialPage";
import Header from "../components/Header";
import Content from "../components/Content";
import Footer from "../components/Footer";
import ScrolltoTop from "../components/ScrolltoTop";

function Home() {
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleConfirm = () => {
    setIsConfirmed(true);
  };

  return (
    <div className="container">
      {!isConfirmed && (
        <div className="overlay">
          <InitialPage onConfirm={handleConfirm} />
        </div>
      )}
      {isConfirmed && (
        <>
          <Header />
          <Content />
          <Footer />
          <ScrolltoTop />
        </>
      )}
    </div>
  );
}
export default Home;